export function SaveIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 001 1h6a1 1 0 100-2H7a1 1 0 00-1 1zm1-4a1 1 0 000 2h4a1 1 0 100-2H7z" />
    </svg>
  );
}
